export type EntriesLike = unknown;

function toStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value
      .flatMap((v) => (v == null ? [] : [String(v)]))
      .map((s) => s.trim())
      .filter(Boolean);
  }

  if (typeof value === 'string') {
    // Support comma-separated strings or single tokens.
    return value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  return [];
}

export function entriesInclude(entries: EntriesLike, needle: string): boolean {
  if (!needle) return false;
  return toStringArray(entries).includes(needle);
}
